/**
 * Vuex Store 主入口
 * 参考 aegismaternity 项目的 store.js 组织方式
 */
import Vue from 'vue'
import Vuex from 'vuex'
import app from './common/app.js'
import userInfo from './common/userInfo.js'

// 使用 Vuex
Vue.use(Vuex)

/**
 * 创建 store 实例
 * 使用模块化组织，参考 aegismaternity 的 combineReducers 方式
 */
const store = new Vuex.Store({
  // Vuex 模块统一在 modules 下挂载
  modules: {
    app
  },
  // 严格模式：在开发环境下，如果 state 被 mutation 之外的方式修改，会抛出错误
  strict: process.env.NODE_ENV !== 'production'
})

// 挂载非 Vuex 的工具方法模块（如用户信息相关方法）
// 使用方式：this.$store.$userInfo.getUserInfoUrl(id)
store.$userInfo = userInfo

export default store



// WEBPACK FOOTER //
// ./src/store/index.js